import React, { useEffect, useState, useRef } from "react";
import MyPage from "../components/MyPage";

function Pension() {
  const [data, setData] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const sectionRef = useRef(null);

  useEffect(() => {
    fetch("/api/pension.json")
      .then(res => res.json())
      .then(d => setData(d));
  }, []);

  useEffect(() => {
    if (!sectionRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("in-view");
        }
      },
      { threshold: 0.25 }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [data]);

  if (!data) return null;

  const openLightbox = (img) => {
    setActiveImage(img);
    setOpenImage(true);
  };

  return (
    <>
     {/* ✅ SEO */}
     <MyPage
        title="Pension | Thrissur Jilla Pravasi Kootayma"
        description="Thrissur Pravasi families united through community engagement and social welfare."
        keywords="Thrissur Pravasi, Community Engagement, Pravasi Activities"
      />
      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner banner-animate">
        <div className="inner-overlay"></div>

        <div className="inner-content">
          <h1>{data.banner.title}</h1>
        </div>

        <div className="breadcrumb">
          {data.banner.breadcrumb}
        </div>
      </section>

      {/* ===== PENSION SECTION ===== */}
      <section className="pension-section" ref={sectionRef}>
        <div className="pension-container">

          {/* LEFT CONTENT */}
          <div className="pension-text reveal-up">
            {data.content.intro.map((p, i) => (
              <p key={i}>{p}</p>
            ))}

            <h2>{data.content.heading}</h2>

            {data.content.points.map((p, i) => (
              <p key={i}>{p}</p>
            ))}

            {/* GALLERY */}
            {/*<div className="pension-images-grid reveal-up">
              {data.gallery.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  className="clickable-image"
                  onClick={() => openLightbox(img)}
                />
              ))}
            </div>*/}
          </div>

          {/* RIGHT IMAGE */}
          <div className="pension-image reveal-up">
            <img
              src={data.sideImage}
              alt="Pension"
              className="clickable-image"
              onClick={() => openLightbox(data.sideImage)}
            />

            <a href={data.button.link} className="btn-green image-btn">
              {data.button.text}
            </a>
          </div>
        </div>
      </section>

      {/* ===== IMAGE LIGHTBOX ===== */}
      {openImage && (
        <div className="image-lightbox" onClick={() => setOpenImage(false)}>
          <span className="close-btn">×</span>
          <img src={activeImage} alt="" />
        </div>
      )}

      {/* ===== CSS ===== */}
      <style>{`
/* ================= INNER BANNER ================= */
.inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}
/* ================= PENSION SECTION ================= */
.pension-section {
  padding: 80px 10%;
}

.pension-container {
  display: flex;
  gap: 60px;
  align-items: flex-start;
}

.pension-text {
  flex: 1;
}

.pension-text h2 {
  font-size: 34px;
  margin: 20px 0;
}

.pension-text p {
  font-size: 16px;
  line-height: 1.7;
}

/* IMAGE */
.pension-image {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pension-image img {
  width: 100%;
  max-width: 420px;
  border-radius: 22px;
}

/* BUTTON */
.btn-green {
  margin-top: 18px;
  padding: 12px 26px;
  background: #9bc53d;
  color: #000;
  border-radius: 6px;
  text-decoration: none;
}

/* GALLERY */
.pension-images-grid {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.pension-images-grid img {
  width: 200%;
  height:150px;
  border-radius: 12px;
}

/* CLICKABLE */
.clickable-image {
  cursor: pointer;
}

/* ================= AREA.JS STYLE ANIMATION ================= */
.reveal-up {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s ease;
}

.pension-section.in-view .reveal-up {
  opacity: 1;
  transform: translateY(0);
}

/* ================= RESPONSIVE ================= */
@media (max-width: 1024px) {
  .pension-container {
    flex-direction: column;
    text-align: center;
  }

  .pension-images-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .pension-section {
    padding: 50px 6%;
  }

  .pension-images-grid {
    grid-template-columns: 1fr;
  }
}

/* ================= LIGHTBOX ================= */
.image-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.image-lightbox img {
  max-width: 90%;
  max-height: 90%;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 32px;
  color: #fff;
  cursor: pointer;
}

/* ================= INNER BANNER RESPONSIVE ================= */
@media (max-width: 768px) {
  .inner-content h1 {
    font-size: 36px;
  }

  .breadcrumb {
    left: 16px;
    padding: 8px 12px;
    font-size: 12px;
  }
}
  /* ================= INNER BANNER ANIMATION ================= */

.banner-animate .inner-content {
  opacity: 0;
  transform: translateY(-40px);
  animation: bannerFadeDown 0.9s ease forwards;
}

.banner-animate .breadcrumb {
  opacity: 0;
  transform: translateY(40px);
  animation: bannerFadeUp 0.9s ease forwards;
  animation-delay: 0.2s;
}

@keyframes bannerFadeDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bannerFadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

      `}</style>
    </>
  );
}

export default Pension;
